export default "__VITE_ASSET__CY4Nf7LA__"